import { render, staticRenderFns } from "./PublicDetail.vue?vue&type=template&id=4c783708&"
import script from "./PublicDetail.vue?vue&type=script&lang=js&"
export * from "./PublicDetail.vue?vue&type=script&lang=js&"
import style0 from "./PublicDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports